module.exports = __webpack_public_path__ + "static/img/play.71a7a82a.svg";